const jobsData = [
//   {
//     id: 1,
//     title: "HR Executive",
//     location: "Pune, India",
//     jobType: "Full-time",
//     experience: "0-1 years of experience in HR, with a strong focus on recruitment",
//     openPositions: 1,
//     description: "We are looking for a proactive and detail-oriented HR Executive to support our Human Resources function, with a primary focus on recruitment and talent acquisition. The role also involves assisting in HR operations to ensure smooth day-to-day HR activities.",
//     postedDate: "2026-05-11",
//     skills: ["HR", "Recruitment"],
//     responsibilities: [
//       "Manage the end-to-end recruitment lifecycle, including sourcing, screening, interviewing, and onboarding candidates",
// 	"Collaborating with hiring managers to understand role requirements and ensure timely closures",
// 	"Build and maintain a strong talent pipeline through various sourcing channels such as job portals, social media, and referrals ",
// 	"Ensure a seamless and positive candidate experience throughout the hiring process ",
// 	"Coordinate interview schedules and follow up with stakeholders for feedback and decision-making ",
// 	"Handle offer rollouts, negotiations, and pre-joining engagement with selected candidates ",
// 	"Track and analyze recruitment metrics such as turnaround time, offer acceptance ratio, and hiring effectiveness ",
// 	"Support employee onboarding, including documentation and induction processes ",
// 	"Maintain and update employee records and HR databases ",
// 	"Assist in attendance management, leave tracking, and payroll inputs", 
// 	"Address employee queries and provide day-to-day HR support ",
// 	"Ensure adherence to company policies and HR processes ",
// 	"Contribute to employee engagement initiatives and HR activities "
//  ],
//     keyQualifications: [
//       "MBA/PGDM in HR or related field "
//     ],
//     niceToHave: [
//       "Strong communication and interpersonal skills",
// 	"Good understanding of recruitment processes and HR practices",
// 	"Ability to multitask and manage time effectively ",
// 	"Attention to detail and organizational skills ",
// 	"Proficiency in MS Office and HR tools/ATS "
//     ], 
//     education: "MBA HR",
//     shift: ["General Shift"],
//     category: "HR",
//     industryType: "Internet / Information Technology",
//     functionalArea: "IT Software - Systems",
//     applyLink: "mailto:careers@dgfuturetech.com?subject=QA%20Engineer%20Application"
//   },
//   {
//     id: 2,
//     title: "Java Developer",
//     location: "Pune, India",
//     jobType: "Full-time",
//     experience: "3 - 4 Years",
//     openPositions: 1,
//     description: "Java Developer with 3-4 years of experience to design and implement high-performance, scalable applications using Spring Boot and the Spring framework. The ideal candidate is proficient with relational databases particularly Oracle), comfortable working with AWS Cloud services, and eager to collaborate in a cross-functional, agile environment.",
//     postedDate: "2025-05-05",
//     skills: ["Java", "Spring Boot", "Oracle", "AWS", "REST API", "ReactJS", "Docker", "Kubernetes", "Jenkins", "GitLab CI"],
//     responsibilities: [
//       "Application Development: Develop, and maintain robust Java applications using Spring Boot and Spring Framework",
//       "API Integration: Create and enhance RESTful APIs to ensure seamless integration with front-end applications, external systems, and services.",
//       "Collaboration: Work closely with cross-functional teams to understand requirements and deliver them to the stakeholders' satisfaction.",
//       "Code Quality & Best Practices: Write clean, maintainable, and well-documented code while adhering to secure coding practices and performance optimization",
//       "Database Management: Implement and optimize database queries using Oracle or other RDBMS, ensuring efficient data retrieval and storage.",
//       "Testing & Debugging: Conduct thorough unit, integration, and system testing; participate in code reviews and troubleshoot production issues",
//       "Process Improvement: Contribute to continuous improvement of development processes, coding standards, and best practices",
//       "Project Execution: Plan and estimate tasks effectively, and handle assigned responsibilities independently under minimal supervision",
//       "Documentation: Maintain comprehensive technical documentation, system configurations, and release notes as and when required",
//       "Support & Maintenance: Investigate and resolve software defects, collaborate with support teams for production fixes, and ensure application stability."
//     ],
//     keyQualifications: [
//       "Education: Bachelor's degree in computer science, Information Technology, Software Engineering, or a related field",
//       "Java & Spring Expertise: 3-4 years of hands-on experience in Java development, with background in Spring Boot, Spring Framework, and enterprise-level application development",
//       "Database Proficiency: Solid knowledge of SQL, Oracle database design, query optimization, and performance tuning",
//       "AWS Experience: Familiarity with AWS services (e.g., ECS, S3) and basic understanding of CI/CD pipelines for cloud deployment",
//       "Architecture: Strong understanding of application architecture, RESTful API principles, and secure coding practices",
//       "Front-End Exposure: Competent in front-end technologies such as ReactJS, JavaScript, and HTML5 for integration and troubleshooting",
//       "Tools & Methodologies: Experience with project management (e.g., Jira), version control systems (e.g., Git, SVN); familiarity with both Agile and Waterfall methodologies",
//       "Code Quality & Testing: Demonstrated ability to write well-documented, maintainable code paired with robust testing (unit, integration, system) and debugging skills ",
//       "Soft Skills: Excellent communication and interpersonal skills; able to collaborate effectively in a dynamic, multicultural environment. ",
//       "Linux Environment: Comfort using Linux/Unix environments for development and deployment is a plus."
//     ],
//     niceToHave: [
//       "Containerization: Experience with Docker and Kubernetes for container orchestration and microservices deployment",
//       "Payment Systems: Knowledge of payment gateway integrations",
//       "DevOps Practices: Familiarity with CI/CD tooling and DevOps processes (e.g., Jenkins, GitLab CI)",
//       "Global Collaboration: Previous experience working with teams across different geographies and time zones"
//     ],
//     preferred: [
//       "Japanese language proficiency at any level",
//       "Cultural Experience: Experience working in globally distributed or multicultural teams"
//     ],
//     education: "B.E./B.Tech or equivalent in relevant field",
//     shift: ["General Shift"],
//     category: "Development",
//     industryType: "Internet / Information Technology",
//     functionalArea: "IT Software - Systems",
//     applyLink: "mailto:careers@dgfuturetech.com?subject=Java%20Developer%20Application"
//   },
//   {
//     id: 3,
//     title: "Bilingual Project Manager",
//     location: "Pune, India",
//     jobType: "Full-time",
//     experience: "10+ Years",
//     openPositions: 1,
//     description: "We are looking for a skilled Bilingual Project Manager & Coordinator fluent in Japanese and English, to lead and coordinate projects efficiently. The ideal candidate will be responsible for managing project timelines, ensuring successful execution, and serving as the key liaison between internal teams and stakeholders.",
//     postedDate: "2026-05-11",
//     skills: ["Project Management", "Japanese Language Skills"],
//     responsibilities: [
//       "Plan, execute, and oversee projects from initiation to completion.",
// "Define project scope, objectives, deliverables, and timelines. ",
// "Monitor project progress, identify potential risks, and implement mitigation strategies.",
// "Ensure projects are delivered on time, within budget, and at the highest quality standards.", 
// "Act as the primary liaison between internal teams, clients, and stakeholders.",
// "Facilitate meetings, prepare reports, and document project updates. ",
// "Provide translation and interpretation support when necessary. ",
// "Maintain accurate project documentation, including reports, meeting notes, and status updates, in both Japanese and English. ",
// "Provide regular progress reports to management and key stakeholders.",
// "Ensure compliance with company policies, industry regulations, and best practices"
//     ],
//     requirements: [
//       "Fluency in Japanese and English (both written and spoken).",
// 	"Proven experience in project management in IT/software development.",
// 	"Strong problem-solving, organizational, and leadership skills. Proficiency in project management tools (e.g., Trello, Asana, Jira, MS Project).",
// 	"Ability to manage multiple projects in a fast-paced environment."
//     ],
//     education: "PMP, PRINCE2, or Agile methodologies",
//     shift: ["General Shift"],
//     category: "IT Project Management",
//     industryType: "Internet / Information Technology",
//     functionalArea: "IT Software - Systems",
//     applyLink: "mailto:careers@dgfuturetech.com?subject=Lead%20Generation%20Specialist%20Application"
//   },

{
id: 3,
title: "Full Stack Tech Lead",
location: "Pune, India",
jobType: "Full-time",
experience: "10+ Years",
openPositions: 1,
 
description: "Full Stack Tech Lead with 10+ years of experience in building and owning scalable web applications. The ideal candidate has strong hands-on expertise in Java, Spring Boot, ReactJS, JavaScript, Oracle, RESTful APIs, AWS, CI/CD, and cloud-native deployments, along with proven experience leading and mentoring a team of 3-5 engineers.",
 
postedDate: "2026-08-26",
 
skills: ["Java", "Spring Boot","ReactJS","JavaScript","HTML5","CSS3","Oracle","SQL","REST API", "AWS", "CI/CD", "Docker", "Kubernetes","JUnit","Mockito","Jest","Cypress","React Testing Library", "Git"
],
 
responsibilities: [
"Backend Development: Design and build robust RESTful APIs and business logic using Java, Spring Boot, and related frameworks.",
"Frontend Development: Develop responsive and dynamic user interfaces using ReactJS, JavaScript, HTML5, and CSS3.",
"Database Management: Design and optimize Oracle database schemas and SQL queries for performance and scalability.",
"Architecture: Own scalable, secure, maintainable, and high-performance full-stack application architecture.",
"Testing & Code Quality: Drive testing, participate in code reviews, and optimize end-to-end application performance.",
"CI/CD & Deployment: Support CI/CD pipelines, AWS services, and containerized application deployments.",
"Collaboration: Work closely with developers, QAs, designers, and other stakeholders to deliver high-quality features.",
"Team Leadership: Lead and mentor a team of 3-5 junior engineers by assigning work, reviewing code, and providing technical guidance.",
"Technical Leadership: Drive engineering standards, design discussions, technical planning, and continuous improvement initiatives.",
"Documentation & Support: Maintain technical documentation and contribute to ongoing application enhancements and production support."
],
 
keyQualifications: [
"Education: Bachelor's degree in Computer Science, Software Engineering, Information Technology, or a related technical field.",
"Experience: 10+ years of strong hands-on software engineering experience, including experience in a Tech Lead or equivalent leadership role.",
"Java & Spring Expertise: Strong hands-on experience with Java, Spring Boot, Spring Framework, and enterprise application architecture.",
"Frontend Expertise: Proficiency in ReactJS and modern JavaScript, with experience building responsive and dynamic user interfaces.",
"Database Proficiency: Strong SQL skills with hands-on experience in Oracle database design, query optimization, and performance tuning.",
"API Development: Strong experience designing, consuming, and integrating RESTful APIs with a solid understanding of HTTP and API design principles.",
"Asynchronous Processing: Experience with asynchronous processing, batch jobs, and reliable background or retry workflows.",
"Cloud & DevOps: Exposure to AWS, CI/CD pipelines, and cloud-native deployment practices.",
"Testing: Experience with testing frameworks such as JUnit, Mockito, Jest, Cypress, or React Testing Library.",
"Architecture & Security: Strong understanding of scalable system architecture, application security, and software development best practices.",
"Leadership: Proven experience mentoring and leading engineers, including responsibility for a team of 3-5 members.",
"Communication: Strong problem-solving, communication, and collaboration skills with a proactive approach."
],
 
niceToHave: [
"AI-Assisted Development: Experience with AI-assisted development tools such as Cursor, Claude, or similar platforms.",
"Frontend Technologies: Experience with TypeScript and modern frontend development practices.",
"Cloud & DevOps: Experience with AWS S3, CloudFront, Jenkins, CI/CD practices, and containerization.",
"Automation Testing: Experience using Playwright for automation testing.",
"Payments & FinTech: Experience in the payments or FinTech domain, including checkout, tokenization, 3-D Secure, settlement, or similar areas.",
"Japanese Language: Japanese language proficiency is a plus.",
"Global Collaboration: Experience working with distributed or multicultural teams."
],
 
preferred: [
"Experience working in globally distributed or multicultural teams.",
"Experience leading and mentoring junior engineers in a production environment."
],
 
education: "Bachelor's degree in Computer Science, Software Engineering, Information Technology, or equivalent relevant field",
 
shift: ["General Shift"],
 
category: "Development",
industryType: "Internet / Information Technology",
functionalArea: "IT Software - Systems",
 
applyLink: "mailto:careers@dgfuturetech.com?subject=Full%20Stack%20Tech%20Lead%20Application"
},
  
// {
//     id: 4,
//     title: "Sales Executive –IT and ERP Solutions",
//     location: "Pune",
//     jobType: "Full-time",
//     experience: "1-3 Years",
//     openPositions: 1,
//     description: "We are hiring a Sales Executive to drive lead generation and outbound sales for IT solutions and infrastructure monitoring solutions. This role focuses on cold calling, LinkedIn outreach, and qualifying B2B prospects.",
//     postedDate: "2026-05-11",
//     skills: ["IT Sales"],
//     responsibilities: [
//       "Generate leads via cold calling, LinkedIn, email, and online research",
// 	"Identify and qualify prospects across target industrie",
// 	"Schedule product demos with IT decision-makers (CTOs, IT Heads, DevOps teams)", 
// 	"Maintain CRM data and ensure timely follow-ups",
// 	"Support marketing campaigns and assist in sales closures"
//     ],
//     requirements: [
//       "Strong verbal and written communication skills",
// 	"Comfortable with cold calling and outbound sales", 
// 	"Basic understanding of IT infrastructure / cloud (preferred) and ERP Solutions ",
// 	"Target-driven, proactive, and self-motivated",
// 	"Excellent verbal and written communication skill"
//      ],
    
//     education: "Bachelor’s or Master’s degree Sales with Basic IT Knowledge",
//     shift: ["General Shift"],
//     category: "Sales",
//     industryType: "Information Technology",
//     functionalArea: "ERP and IT Monitoring",
//     applyLink: "mailto:careers@dgfuturetech.com?subject=SeniorQALead"
//   },
  {
    id: 5,
    title: "Application Support Engineer",
    location: "Pune, India",
    jobType: "Full-time",
    experience: "2 - 5 Years",
    openPositions: 3,
    description: "We are looking for a Technical Support Engineer with hands-on experience in Linux and Windows Server operating systems, RDBMS, and excellent troubleshooting skills. The ideal candidate should be well-versed with ITSM/ITIL Framework and have experience with hardware, networking components, or cloud technologies.",
    postedDate: "2025-05-05",
    skills: ["Linux", "Windows Server", "RDBMS", "MySQL", "SQL Server", "DynamoDB", "Oracle", "AWS", "Azure", "ITSM", "ITIL", "Firewall", "Anti-Virus", "Data Encryption"],
    responsibilities: [
      "Configure and maintain hardware and networking components",
      "Manage cloud technologies and services",
      "Implement and maintain security systems",
      "Troubleshoot system issues and provide solutions",
      "Document system configurations and procedures"
    ],
    requirements: [
      "Hands-on experience of Linux and Windows Server operating systems",
      "Experience in RDBMS (MySQL, SQL Server, DynamoDB, Oracle)",
      "Excellent troubleshooting and problem-solving skills",
      "Excellent communication and documentation skills",
      "Knowledge of ITSM/ITIL Framework"
    ],
    mustHave: ["Japanese Language Skills"],
    jobSkills: [
      "3+ years of experience working in IT industry.",
      "Hands-on/Intermediate knowledge of AWS and DevOps principles (Jenkins, CI/CD pipeline)",
      "Good hands-on experience in writing and troubleshooting SQL queries for MySQL/PostgreSQL database",
      "Basic understanding of SQL query optimization.",
      "Good understanding of Incident Management process",
      "Excellent documentation skills using Google Docs, MS Excel, and MS Word ",
      "Excellent written & spoken communication skills in English",
      "Willingness to work in rotational shifts",
      "Knowledge of capital markets, reinsurance, exposure to banking and finance industry."
    ],
    tools: ["Google Docs/Drive", "AWS CLI", "Oracle WebLogic", "DynamoDB", "A-Auto", "F5-BIG-IP"],
    education: "BCS, BCA, MCS, MCA, B.E./B.Tech (IT / Computers / Electronics)",
    shift: [
      "1st Shift: 6am to 3pm",
      "2nd Shift: 2pm to 11pm",
      "3rd Shift: 10pm to 7am"
    ],
    shiftNote: "There will be rotational shifts. Shifts change tentatively after a month's gap depending upon the work situation.",
    category: "System Administration",
    industryType: "FinTech",
    functionalArea: "IT Software - Systems",
    applyLink: "mailto:careers@dgfuturetech.com?subject=System%20Administrator%20Application"
  },
  {
id: 6,

    title: "QA Engineer",

    location: "Pune, India",

    jobType: "Full-time",

    experience: "4+ Years",

    openPositions: 2,

    description: "We are looking for a QA Engineer with hands-on experience",

    postedDate: "2026-05-11",

    skills: ["QA"],

    responsibilities: [

     "Design, develop, and execute automation scripts using open-source tools. Create detailed, comprehensive, and well-structured test plans and test cases. ",

	"Knowledge of software QA methodologies, tools, and processes. Hands-on experience with both white box and black box testing, automated testing tools.", 

	"Experience in software development." 

    ],

    education: "BCS, BCA, MCS, MCA, B.E./B.Tech (IT / Computers / Electronics)",

    category: "System Administration",

    industryType: "Internet / Information Technology",

    functionalArea: "IT Software - Systems",

    applyLink: "mailto:careersdgft@dgfuturetech.com?subject=QA%20Engineer%20Application"

}

];
export default jobsData;